import React from 'react'
import DataSetDetails from './DataSetDetails';
import PreviewBarChart from '../../Profile/DataSets/PreviewBarChart';
import PreviewHistogram from '../../Profile/DataSets/PreviewHistogram';

const DatasetCard = ({ title, overview, price, start_date, extracted_from_total_accounts,
    end_date, actionName ,onPurchase, notPurchased, expires_at, quality_score,
    profile_completeness, avg_relevance_score, personality_profile, chat_history,discussion_activity,
    msg_per_chats, total_msg_per_chats,bar_chart_data,histogram_data,
}) => (

    <>
        <div className='bg-white px-2 py-3 sm:p-5 text-black rounded-md my-4'>

            {actionName === "Purchase" &&
            <h3 className='text-xl font-bold mt-4 mb-8'>Showing results for your search query...</h3>
            }

         <DataSetDetails
           price={price}
           quality_score={quality_score}
           profile_completeness={profile_completeness}
           avg_relevance_score={avg_relevance_score}
           personality_profile={personality_profile}
           chat_history={chat_history}
           discussion_activity={discussion_activity}
           msg_per_chats={msg_per_chats}
           total_msg_per_chats={total_msg_per_chats}
           startDate={start_date}
           totalAccounts={extracted_from_total_accounts}
           endDate={end_date}
           actionName={actionName}
            />

            <div className="">
                <PreviewBarChart data={bar_chart_data} />
            </div>

            <div className="">
                <PreviewHistogram frequencyData={histogram_data} />
            </div>

            <div className='my-3 flex'>

               {/* Show this button if user has this data set  */}
            {!notPurchased &&
            <div className='sm:w-[20%]' >
                <p>Expires: <b>{expires_at}</b></p>
            </div>
            }

            {actionName !== "Active"
            &&
            <div className={`flex justify-end w-[80%] space-x-2 ${notPurchased && "w-full"}`}>
            <button
                onClick={() => onPurchase(title)}
                className="bg-[#7AA65F] text-white px-2.5 sm:px-6 py-2 rounded
                 hover:bg-green-600 transition-colors"
            >
                {actionName}
            </button>
                </div>
            }

            </div>



        </div>

    </>

);

export default DatasetCard
